import { useStoreon } from 'storeon/react'

interface IuseModal {
  closeModal: () => void
  openModal: (modal: string, modalProps?: object) => void
  isOpen: boolean
  showModal: string
  modalProps: any
}

const useModal = (): IuseModal => {
  const { dispatch, showModal, modalProps } = useStoreon('showModal', 'modalProps')

  const openModal = (modal, modalProps = {}): void => {
    dispatch('modal/toggle', { modal, modalProps })
  }
  const closeModal = (): void => dispatch('modal/close')
  const isOpen = showModal !== null
  return {
    closeModal,
    openModal,
    isOpen,
    showModal,
    modalProps
  }
}

export default useModal
